import React from "react";
import { ProgressBar } from "react-bootstrap";
import { Skeleton } from "@material-ui/lab";

export const ProgressVenditori = (props) => (
  <>
    <div className="row">
      <div className="col-lg-12 col-sm-12">
        <h6 className="col-12 pl-7">TEST DRIVE:</h6>
        <div className="col-12 p-7">
          <label className="col-12">
            Settimanale
            {props.contractsProgressBar.weekWorks !== undefined
              ? ": " +
                props.contractsProgressBar.weekWorks +
                "/" +
                props.contractsProgressBar.obiettivoSettimanale
              : null}
          </label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="success"
              now={
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentageWeek !== undefined
                  ? props.contractsProgressBar.percentageWeek
                  : 0
              }
              label={`${
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentageWeek !== undefined
                  ? props.contractsProgressBar.percentageWeek
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
        <div className="col-12 p-7">
          <label className="col-12">
            Mensile
            {props.contractsProgressBar.monthWorks !== undefined
              ? ": " +
                props.contractsProgressBar.monthWorks +
                "/" +
                props.contractsProgressBar.obiettivoMensile
              : null}
          </label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="info"
              now={
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentageMonth !== undefined
                  ? props.contractsProgressBar.percentageMonth
                  : 0
              }
              label={`${
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentageMonth !== undefined
                  ? props.contractsProgressBar.percentageMonth
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
        <div className="col-12 p-7">
          <label className="col-12">
            Intervallo date
            {props.contractsProgressBar.periodWorks !== undefined
              ? ": " +
                props.contractsProgressBar.periodWorks +
                "/" +
                props.contractsProgressBar.obiettivoPeriod
              : null}
          </label>
          {!props.loading && props.selectedUser ? (
            <ProgressBar
              animated
              variant="warning"
              now={
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentagePeriod !== undefined
                  ? props.contractsProgressBar.percentagePeriod
                  : 0
              }
              label={`${
                props.contractsProgressBar !== undefined &&
                props.contractsProgressBar.percentagePeriod !== undefined
                  ? props.contractsProgressBar.percentagePeriod
                  : 0
              }%`}
            />
          ) : (
            <Skeleton />
          )}
        </div>
      </div>
    </div>
  </>
);
